import Vue from 'vue';
import { ChatbotComponent, initializeChatbotService } from '@amplify/chatbot-core';

Vue.use(ChatbotComponent);

export default function (ctx, inject) {
  inject('chatbotService', initializeChatbotService(ctx));
}